import { PayloadAction } from '@reduxjs/toolkit';

import { StationsState } from '../../types';

export const setMarkerServiceStations = (
  state: StationsState,
  action: PayloadAction<StationsState['markerServiceStations']['data']>
) => {
  state.markerServiceStations.data = action.payload;
};

export const setPricesServiceMapData = (
  state: StationsState,
  action: PayloadAction<StationsState['markerServiceStations']['priceServiceMapData']>
) => {
  state.markerServiceStations.priceServiceMapData = action.payload;
};
